<div class="table__item">
  <div>
    <span class="cursor-pointer" (click)="onDownloadInvoice(invoice.id)">
      <img src="assets/icon-pdf.svg" width="49" height="64" alt="PDF" />
    </span>
  </div>
  <div>
    <div>{{ invoice.number }}</div>
    <div>{{ invoice.created_at | date: 'dd.MM.yyyy' }}</div>
    <div>{{ +invoice.amount | price }}</div>
  </div>
  <div>
    <span class="cursor-pointer" (click)="onDownloadInvoice(invoice.id)">
      <img
        src="assets/icon-download.svg"
        width="110"
        height="104"
        alt="Download icon"
      />
    </span>
  </div>
</div>
